export class Organization {

  orgUnitId!: string;
  description!: string;
  pbcId!: string;
  pbcDescription!: string;
  responsibilityId!: string;
  responsibilityDescription!: string;
  serviceRepId!: string;
  serviceRepDescription!: string;
  applicationEngineerId!: string;
  applicationEngineerDescription!: string;
  controllingOrgId!: string;
  controllingOrgDescription!: string;
  regionID!: string;
  salesmanID!: string;
  prnCode!: string;
  defaultInstallCode!: string;
  mnemonic!: string;
  erpReferenceId!: string;
  createUser!: string;
  createTimestamp!: Date;
  updateUser!: string;
  updateTimestamp!: Date;
  typeCode!: string;
  typeDescription!: string;
  priceListId!: string;
  priceListDescription!: string;
  installCode!: string;
  installDescription!: string;
  paymentTermsCode!: string;
  paymentTermsDescription!: string;
  deliveryTermsCode!: string;
  deliveryTermsDescription!: string;
  transportationTermsCode!: string;
  transportationTermsDescription!: string;
  freightTermsCode!: string;
  freightTermsDescription!: string;
  classificationCode!: string;
  classificationDescription!: string;
  statusCode!: string;
  statusDescription!: string;
  siteStatusCode!: string;
  siteStatusDescription!: string;
  customerStatusCode!: string;
  customerStatusDescription!: string;
  channelStatusCode!: string;
  channelStatusDescription!: string;
  active!: boolean;
  masterOrganization!: boolean;
  site!: boolean;
  customer!: boolean;
  channel!: boolean;
  vendor!: boolean;
  validBuyingOrg!: boolean;
  validSellingOrg!: boolean;
  parentOrg!: string;
  internal!: boolean;
  defaultAHRITradeArea!: string;
  cancelEffectiveDate!: Date;
  replacedByOrgUnitID!: string;

}
